// extracted by mini-css-extract-plugin
module.exports = {"container":"Dashboard_container__3N4UX","questions":"Dashboard_questions__1osp-"};